import React from "react";
import "./style.css";
import { OnboardingStep } from "../../components/OnboardingStep";

const OnboardingPage = () => {
  return <OnboardingStep />;
};

export default OnboardingPage;
